export const useHourPeriod = (setting: string | undefined, systemTimezone = -4): boolean => {
	const settingPattern = /(\d+)\s*-\s*(\d+)/;
	if (!setting || !settingPattern.test(setting)) {
		return false;
	}
	const period = {
		from: parseInt(setting.replace(settingPattern, '$1')),
		to: parseInt(setting.replace(settingPattern, '$2'))
	};
	if (period.from === period.to || [period.from, period.to].findIndex(period => isNaN(period) || period < 0 || period > 23) !== -1) {
		return false;
	}
	
	try {
		const localNow = new Date();
		// system timezone = -4, which means the offset has to be 4 to make it UTC+0
		const SYSTEM_TIMEZONE_OFFSET = systemTimezone * -1;
		// when user located in UTC+8, the offset should be -8; 
		// getTimezoneOffset() will return offset in minutes, so we convert it back to hours
		const localOffset = localNow.getTimezoneOffset() / 60;
		// the delta represents the hours to convert local-timezone to system-timezone
		const offsetDelta = SYSTEM_TIMEZONE_OFFSET - localOffset;
		// mod 24 will make sure the output follow 24-hour time convention
		const localHourInSystemTimezone = (localNow.getHours() + offsetDelta + 24) % 24;
    
		return (period.from < period.to) ? period.from <= localHourInSystemTimezone && localHourInSystemTimezone < period.to
			: (period.from <= localHourInSystemTimezone || localHourInSystemTimezone < period.to)
	} catch {
		return false;
	}
};